import { Centrifuge } from 'centrifuge';
import { SERVICE_NAME } from '../constants';

let cf;

export const initCf = ({ centrifugoURL, channel, token = '' }) => {
  cf = new Centrifuge(centrifugoURL, {
    protocol: 'json',
    data: {
      Authorization: token,
      channel,
      productTypes: [SERVICE_NAME],
      projects: [],
    },
  });
  return cf;
};

export const getCf = () => cf;
